import { PlanDetails, PlanDurations, PlanTypes } from 'Interfaces/Billing';

export function financialReasonPeriodBySubscriptionOption(
  planDuration: PlanDurations,
): 'monthly' | 'yearly' {
  return planDuration === PlanDurations.ANNUALLY ? 'yearly' : 'monthly';
}

export function targetDiscountBySubscriptionOption(plan: PlanDetails) {
  return plan.duration === PlanDurations.MONTHLY && plan.type === PlanTypes.BUSINESS
    ? 50
    : plan.duration === PlanDurations.ANNUALLY
    ? 30
    : 15;
}

export function discountOrLess(currentPercent: number, plan: PlanDetails) {
  const targetPercent = targetDiscountBySubscriptionOption(plan);
  return currentPercent < targetPercent ? targetPercent : 15;
}
